import {
    createTable,
    RenderingPresetType,
    TableHeaderSpec
} from "../../../../../components/table/CreateTable.tsx";
import {Subscription} from "./Subscription.tsx";


interface Props {
    data: Array<Subscription>,
}

export function SubscriptionsTable({data}: Props) {

    const tableSpec: TableHeaderSpec<Subscription> = {
        title: `${data.length} abonnementen`,
        columns: [
            {
                name: 'Leverancier',
                field: 'relation_name',
            },
            {
                name: 'Startdatum',
                field: 'start_date',
            },
            {
                name: 'Frequentie',
                field: 'frequency',
            },
            {
                name: 'Laatste betaling',
                field: 'last_payment_date',
            },
            {
                name: 'Cumulatieve bedrag',
                field: 'cumulative_amount',
                renderingPreset: RenderingPresetType.Money
            },
        ],
        options: {
            disableTopPaginationWidget: true,
        },
    }

    const TableComponent = createTable<Subscription>(data, tableSpec)

    return (
        <>
            {TableComponent()}
        </>
    )
}
